var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRunning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M4.732 20.716a2.56 2.56 0 1 0 0-5.118 2.56 2.56 0 0 0 0 5.118",
  opacity: 0.6
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M21.2 18.447a2.221 2.221 0 1 0 0-4.443 2.221 2.221 0 0 0 0 4.443",
  opacity: 0.3
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M19.17 7.243a1.835 1.835 0 1 0 .001-3.67 1.835 1.835 0 0 0 0 3.67",
  opacity: 0.1
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M2.716 14.469c1.5 0 2.716-1.186 2.716-2.65S4.216 9.17 2.716 9.17 0 10.356 0 11.82c0 1.464 1.216 2.65 2.716 2.65",
  opacity: 0.7
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M10.519 24c1.363 0 2.469-1.077 2.469-2.406s-1.106-2.406-2.47-2.406c-1.363 0-2.469 1.077-2.469 2.406S9.155 24 10.52 24",
  opacity: 0.5
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M16.864 22.946c1.296 0 2.346-1.023 2.346-2.284s-1.05-2.284-2.346-2.284c-1.295 0-2.345 1.023-2.345 2.284s1.05 2.284 2.345 2.284",
  opacity: 0.4
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M5.654 8.315c1.569 0 2.84-1.24 2.84-2.772 0-1.53-1.271-2.771-2.84-2.771s-2.84 1.24-2.84 2.771 1.272 2.772 2.84 2.772",
  opacity: 0.8
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M21.901 12.514c1.16 0 2.099-.923 2.099-2.06s-.94-2.06-2.099-2.06-2.099.922-2.099 2.06.94 2.06 2.099 2.06",
  opacity: 0.2
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M12.7 5.988A2.994 2.994 0 1 0 12.7 0a2.994 2.994 0 0 0 0 5.988"
})));
export { SvgRunning as ReactComponent };
export default __webpack_public_path__ + "static/media/running.2d067a5f.svg";